import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import AvatarTooltip from "@Shared/components/general/avatar-tooltip";
import TimelineItemCard from "../utils/timeline-card.vue";
import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogFollowUp",
  components: {
    TimelineItemCard,
    AvatarTooltip
  },
  mixins: [ChangelogMixin],
  props: {
    value: {
      type: null,
      required: true
    },
    operation: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    userDetails: {
      type: Object,
      required: true
    },
    insertionTimestamp: {
      type: String,
      required: true
    }
  },
  methods: {
    followUpDate(value) {
      return `${this.$options.filters.momentLocal(value.scheduledDate, "MMM. DD, YYYY")} @ ${moment(value.scheduledTime, "'HH:mm'").format("LT")}`;
    },
    isCompleteCheck(complete) {
      return complete ? "check-square" : "square-o";
    },
    firstThreeAssignees(value) {
      var _value$assignees$slic, _value$assignees;
      return (_value$assignees$slic = (_value$assignees = value.assignees) == null ? void 0 : _sliceInstanceProperty(_value$assignees).call(_value$assignees, 0, 3)) != null ? _value$assignees$slic : [];
    }
  }
});